import React, { useMemo } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye } from '@fortawesome/free-solid-svg-icons';
import { useFormsContext } from 'pages/forms/context/FormsProvider';
import { useStyles } from './styles';
import { IconButton } from '@material-ui/core';
import { useFormData } from 'pages/forms/hooks/useFormData';
import { Preview } from 'pages/formsCreate/Preview';
import { InjectedRouter } from 'react-router';

interface IProps {
  rowIndex: number;
  router?: InjectedRouter;
}

export const ViewFormButton = ({ rowIndex, router }: IProps) => {
  const { data, currentSupplierId } = useFormsContext();
  const styles = useStyles();
  const { loadFormData, isLoadingFormData, formData, isModalOpen, setIsModalOpen } = useFormData();
  const rowData = useMemo(() => data[rowIndex], [data, rowIndex]);

  const handleEdit = () => {
    if (isModalOpen) return setIsModalOpen(false);

    setIsModalOpen(true);
    loadFormData({ id: rowData?.idForm, supplierId: currentSupplierId });
  };

  const handleClose = () => setIsModalOpen(false);

  const enableEdit = useMemo(() => {
    return !rowData ? false : rowData.inDraft === 'S';
  }, [rowData]);

  return (
    <>
      {isModalOpen && formData && (
        <Preview form={formData} onClose={handleClose} router={router} enableEdit={enableEdit} />
      )}
      <IconButton disabled={isLoadingFormData} onClick={handleEdit} className={styles.button}>
        <FontAwesomeIcon icon={faEye} />
      </IconButton>
    </>
  );
};
